//import { IDropdownOption } from "office-ui-fabric-react";
import { IComboBoxOption } from 'office-ui-fabric-react/lib-commonjs';
import SharePointPackage from '../../src/models/SharePointPackage'

export const GetSharePointAppVersions = (packageId: string | undefined, sharePointPackages: SharePointPackage[] | undefined): IComboBoxOption[] => {

    var versions: IComboBoxOption[] = [];
    var maxVersion: string | undefined = undefined;

    if (sharePointPackages && sharePointPackages.length > 0) {

        var appPackages = sharePointPackages.filter(p => p.id.toLowerCase() === packageId?.toLowerCase());

        if (appPackages.length > 0) {

            var versionedAppPackages = appPackages.filter(v => v?.version !== null);

            var sortedVersions = versionedAppPackages.sort((a, b) => compareVersion(a.version as string, b.version as string)).reverse();

            if (sortedVersions.length > 0) {
                maxVersion = sortedVersions[0].version;
            }

            versions = appPackages.map(p => {
                return {
                    key: p.version === null ? "Latest" : p.version!,
                    text: p.version === null || p.version === undefined ? `Latest (${maxVersion})` : p.version
                }
            })
        }
    }
    
    //Add uninstall option
    versions.push({
        key: "Uninstall",
        text: "Uninstall"
    })

    return versions;
}

export const compareVersion = (versionA: string | number[], versionB: string | number[]): number => {
    var a;
    var b;

    if (Array.isArray(versionA)) {
        a = versionA;
    } else {
        a = versionA.split(".").map(v => Number.parseInt(v));
    }

    if (Array.isArray(versionB)) {
        b = versionB;
    } else {
        b = versionB.split(".").map(v => Number.parseInt(v));
    }


    for (var i = 0; i < a.length || i < b.length; ++i) {
        var aInt: number = i < (a.length as number) ? a[i] : 0;
        var bInt: number = i < (b.length as number) ? b[i] : 0;

        var dif = aInt - bInt;

        if (dif > 0) {
            return 1;
        }
        else if (dif < 0) {
            return -1;
        }
    }
    return 0;
}